import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) => theme.palette?.background?.paper || 'white'};
  border-radius: ${({ theme }) => theme.layout?.borderRadius || '10px'};
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  padding: ${({ theme }) => theme.layout?.spacing?.lg || '1.5rem'};
  box-shadow: ${({ theme }) => theme.layout?.shadow?.lg || '0 4px 12px rgba(0, 0, 0, 0.15)'};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    font-size: ${({ theme }) => theme.typography?.sizes?.h2 || '1.5rem'};
    color: ${({ theme }) => theme.modePalette?.text || '#000'};
  }
`;

export const ModalBody = styled.div`
  margin-top: ${({ theme }) => theme.layout?.spacing?.md || '1rem'};
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: ${({ theme }) => theme.typography?.sizes?.h2 || '1.5rem'};
  color: ${({ theme }) => theme.modePalette?.textSecondary || '#555'};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette?.primary?.main || '#007bff'};
  }
`;